<template>
    <q-card class="preview-title q-pa-md" style="background-color: #212121; user-select: none">
      <PreviewThumbnail class="preview-thumbnail-wrapper" :url="previewUrl"/>
      <q-card-section align="center">
        <div class="text-h6 q-ma-sm">{{ props.link.title || "Title example" }}</div>
        <div class="text-subtitle2">{{ props.link.subtitle }}</div>
      </q-card-section>

      <template v-for="(action, index) in props.link.actions">
        <SocialThumb
            v-if="action.command"
            :action="action"
            class="q-my-md"
            @thumbClick="() => onSocialClicked(index)"
            :disabled="state.done[index]"/>
      </template>

      <q-card-section align="center">
        <div class="text-subtitle1">unlock progress {{ amountDone }} / {{ props.link.actions?.length }}</div>
        <q-linear-progress reverse :value="progress" rounded :indeterminate="inProgress"
                           color="green-12" class="q-mt-md"/>
      </q-card-section>


      <q-card class="col-6" style="border-radius: 8px" :style="{ 'background-color': isReleased ? '#40ad7a' : '#474747'}">
        <q-card-section class="q-px-md q-py-sm" @click="lockedLinkClick()">
          <div class="row items-center justify-center">
            <q-icon v-if="!isReleased" name="lock" size="md" />
            <q-icon v-if="isReleased" name="lock_open" size="md" />
            <div class="text-h6 q-ml-sm" style="color: white">Unlock link</div>
          </div>
        </q-card-section>
      </q-card>
    </q-card>
</template>

<script setup lang="ts">
import type {Link} from "@/types/link.type";
import {QCard, QLinearProgress} from "quasar";
import {computed, reactive} from "vue";
import SocialThumb from "@/components/LinkPreview/SocialThumb.vue";
import PreviewThumbnail from "@/components/LinkPreview/PreviewThumbnail.vue";

export interface LinkPreviewProps {
  link: Link
}

const props = defineProps<LinkPreviewProps>()

const inProgress = computed<boolean>(() => !!Object.keys(state.pending).length)
const amountDone = computed<number>(() => Object.keys(state.done).length)
const isReleased = computed<boolean>(() => amountDone.value === props.link.actions?.length)
const previewUrl = computed<string>(() => {
  const isEnabled = props.link.widgets?.preview?.isEnabled
  if (!isEnabled) return

  return props.link.widgets?.preview?.previewUrl || props.link.url
})

const progress = computed<number>(() => {
  if (!props.link.actions?.length) return 0;
  return amountDone.value / props.link.actions!.length!
})

interface PreviewState  {
  done: Record<number, boolean>
  pending: Record<number, boolean>
}
const state = reactive<PreviewState>({ done: {}, pending: {} })

function onSocialClicked(index: number) {
  state.pending[index] = true
  setTimeout(() => {
    delete state.pending[index]
    state.done[index] = true
  }, 8000)
}

function lockedLinkClick() {
  if (isReleased.value){
    window.open(props.link.url)
  }
}
</script>

<style scoped>
.preview-thumbnail-wrapper {
  box-shadow: #ebebeb40 0 4px 11px -2px, #ffffff38 0 0 0 1px;
}
</style>